module.exports = __webpack_public_path__ + "static/2-f5219f3b71172e581ad8e0d9e7f880dc.jpg";